// Profile data fetcher
import useProfileData from '../../hooks/useProfileData';
// View-only profile display
import ProfileCard from './ProfileCard';

// Other user's profile (view-only)
function ProfileViewer({ userId }) {
  const { profile } = useProfileData(userId);

  return <ProfileCard profileData={profile} />;
}

export default ProfileViewer;
